export default __webpack_public_path__ + "static/media/ILPlatform_Project.251007b1.png";